import { useEffect, useState } from "react";

const TTL_MS = 4500; // a ping every ~3s keeps it alive; silence clears it

/** Who is typing / recording in a conversation right now (other users only).
 *  Fed by Thread's conv WebSocket via the "osc-conv-typing" window event. */
export function useTypingPresence(conversationId, myId) {
  const [active, setActive] = useState([]); // [{user_id, name, kind}]
  useEffect(() => {
    let entries = {};
    let timer;
    const publish = () => {
      const now = Date.now();
      entries = Object.fromEntries(Object.entries(entries).filter(([, v]) => now - v.at < TTL_MS));
      setActive(Object.values(entries).map(({ user_id, name, kind }) => ({ user_id, name, kind })));
      clearTimeout(timer);
      if (Object.keys(entries).length) timer = setTimeout(publish, 1000);
    };
    const onEvt = (e) => {
      const d = e.detail || {};
      if (d.conversation_id !== conversationId || !d.user_id || d.user_id === myId) return;
      if (d.kind === "stop") delete entries[d.user_id];
      else entries[d.user_id] = { user_id: d.user_id, name: d.name || "", kind: d.kind || "typing", at: Date.now() };
      publish();
    };
    window.addEventListener("osc-conv-typing", onEvt);
    return () => { window.removeEventListener("osc-conv-typing", onEvt); clearTimeout(timer); };
  }, [conversationId, myId]);
  return active;
}

/** Header line: "Ana está digitando…" / "Ana está gravando áudio…" */
export function presenceLabel(active, t) {
  if (!active.length) return "";
  const rec = active.filter((a) => a.kind === "recording");
  const first = rec[0] || active[0];
  const kind = rec.length ? "recording" : "typing";
  const name = (first.name || "").split(" ")[0];
  if (active.length > 1) return t(kind === "recording" ? "presence_recording_many" : "presence_typing_many");
  return t(kind === "recording" ? "presence_recording_one" : "presence_typing_one").replace("{name}", name);
}
